import React from "react";
import { useVatReport } from "./VatReportProvider.js";
import { getMonthName } from "../../../model/accounting/date/getMonthName.js";

/**
 * Displays title of the monthly VAT report.
 */
export const VatReportTitle = () => {
  const { year, month } = useVatReport();

  return (
    <h2>
      Käibemaks {getMonthName(month)}, {year}
    </h2>
  );
};
